<div class="overlay-inner-wrapper">
  @if (!isInspektion()) {
    <header class="header-2">
      <div class="branding">
        <span class="title">{{ 'Neuen Mangel anlegen' | mrTranslate }}</span>
      </div>
      <div class="header-actions">
        <a href="javascript:void(0);" class="nav-link nav-icon" (click)="close()">
          <cds-icon shape="times" />
        </a>
      </div>
    </header>
  }
  <div
    id="mangelerfassungsWrapper"
    class="w-100-p padding-10-lr padding-12-b scroll-y"
    [ngClass]="isInspektion() ? 'h-100' : 'h-60'">
    <div
      class="clr-row nxm"
      [class.clr-flex-wrap-reverse]="isInspektion()"
      [class]="isInspektion() ? 'h-100' : 'auto-height-lg-100'">
      <div class="clr-col-12 d-f col auto-height-lg-100" [class.clr-col-lg-6]="!isInspektion()">
        <!-- Top-Sektion - Felder zum eintragen -->
        <form
          #mangelForm
          id="mangel-erfassung-form"
          [formGroup]="formTopGroup"
          #form="ngForm"
          (ngSubmit)="saveIfValid()"
          clrForm
          [clrLayout]="isInspektion() ? 'vertical' : 'horizontal'"
          class="width100 d-f col"
          [clrLabelSize]="isInspektion() ? 12 : 4">
          @if (isInspektion()) {
            <div class="margin-5-t clr-align-self-end d-f">
              @if (isLoading()) {
                <clr-spinner [clrMedium]="true" class="margin-6-lr" />
              }
              <app-preview-thumbnails
                [acceptTypes]="'image/*'"
                [hidden]="mangelGr.disabled"
                [onlyIcons]="true"
                [maxAmount]="6"
                (deleteFile)="deletedFiles.push($event)" />
              <div class="flex-0-0-auto btn-group btn-icon">
                <button
                  type="button"
                  class="btn btn-icon"
                  [title]="'Neue Mangelverknüpfung erstellen' | mrTranslate"
                  (click)="addMangelTree()"
                  [disabled]="formTopGroup.dirty || !canCreateMangelBaumNode()">
                  <cds-icon shape="mangelbaum_add" />
                </button>
              </div>
              <div class="flex-0-0-auto btn-group btn-primary btn-icon">
                <button
                  type="button"
                  class="btn btn-icon btn-success"
                  [title]="'Neu' | mrTranslate"
                  (click)="addMangel()">
                  <cds-icon shape="file" />
                </button>
                <button
                  type="button"
                  class="btn btn-icon btn-danger"
                  [title]="'Löschen' | mrTranslate"
                  (click)="deleteMangel()"
                  [disabled]="!selectedMangel()">
                  <cds-icon shape="times" />
                </button>
                <button
                  type="submit"
                  class="btn btn-icon margin-12-l"
                  [title]="'Speichern' | mrTranslate"
                  [clrLoading]="saveState()">
                  <cds-icon shape="floppy" />
                </button>
              </div>
            </div>
          }
          <div class="clr-row nxm" [class.margin--35-t]="isInspektion()">
            @if (linieGr.enabled) {
              <!-- von + bis -->
              <ng-container formGroupName="linieGr">
                @if (form.submitted && linieGr.errors?.['mindestens-ein-wert']) {
                  <div class="clr-row nxm clr-col-12 clr-col-sm-10 clr-col-md-8 clr-col-lg-6">
                    <clr-alert class="w-100-p" clrAlertType="danger" [clrAlertClosable]="false">
                      <clr-alert-item>
                        <span class="alert-text">
                          {{ 'Der Startmeter oder Endmeter muss eingetragen sein' | mrTranslate }}
                        </span>
                      </clr-alert-item>
                    </clr-alert>
                  </div>
                  <div class="clr-break-row"></div>
                }
                @if (linieGr.errors?.['not-in-Direction']; as err) {
                  <div class="clr-row nxm clr-col-12 clr-col-sm-10 clr-col-md-8 clr-col-lg-6 clr-break-row">
                    <clr-alert class="w-100-p" clrAlertType="danger" [clrAlertClosable]="false">
                      <clr-alert-item>
                        <span class="alert-text">
                          {{
                            'Der Startmeter muss ' + (err.upwards ? 'kleiner' : 'größer') + ' als der Endmeter sein'
                              | mrTranslate
                          }}
                        </span>
                      </clr-alert-item>
                    </clr-alert>
                  </div>
                  <div class="clr-break-row"></div>
                }
                <div [class]="isInspektion() ? 'clr-col-auto' : 'clr-col-12'">
                  <ng-container *ngTemplateOutlet="!drehung.isOn ? start : end" />
                </div>
                <div [class]="isInspektion() ? 'clr-col-auto' : 'clr-col-12'">
                  <ng-container *ngTemplateOutlet="!drehung.isOn ? end : start" />
                </div>
                <ng-template #start>
                  <clr-number-input-container>
                    <label class="w-100-p">
                      {{ (!drehung.isOn ? 'von' : 'bis') | mrTranslate }}
                      <div class="btn-group btn-sm btn-icon btn-outline" style="margin: -7px 0; float: inline-end">
                        @if (drehung.isOn) {
                          <button
                            type="button"
                            class="btn"
                            [title]="'Werte einsetzen' | mrTranslate"
                            tabindex="-1"
                            (click)="copyLinieValue('von', 'bis')">
                            <cds-icon shape="paste" />
                          </button>
                        }
                        <button
                          type="button"
                          class="btn"
                          [title]="'Geoposition orten' | mrTranslate"
                          tabindex="-1"
                          (click)="findPositionAndAutofill('von')"
                          [clrLoading]="geoState()">
                          <cds-icon shape="map-marker" />
                        </button>
                      </div>
                    </label>
                    <input
                      clrNumberInput
                      formControlName="von"
                      [value]="linieGr.controls.von.value | drehung: drehung.summe"
                      (change)="linieGr.controls.von.setValue(drehungPipe.back($event.target.value, drehung.summe))"
                      type="number"
                      [step]="0.1" />
                    <clr-control-error *clrIfError="'required'">
                      {{ 'Erforderlich' | mrTranslate }}
                    </clr-control-error>
                    @if (linieGr.controls.von.errors?.min; as err) {
                      <clr-control-error>
                        {{ 'Der Wert ist ' + (!drehung.isOn ? 'kleiner' : 'größer') + ' als' | mrTranslate }}
                        {{ err.min | drehung: drehung.summe }}
                      </clr-control-error>
                    }
                    @if (linieGr.controls.von.errors?.max; as err) {
                      <clr-control-error>
                        {{ 'Der Wert ist ' + (!drehung.isOn ? 'größer' : 'kleiner') + ' als' | mrTranslate }}
                        {{ err.max | drehung: drehung.summe }}
                      </clr-control-error>
                    }
                  </clr-number-input-container>
                </ng-template>
                <ng-template #end>
                  <clr-number-input-container>
                    <label class="w-100-p">
                      {{ (!drehung.isOn ? 'bis' : 'von') | mrTranslate }}
                      <div class="btn-group btn-sm btn-icon btn-outline" style="margin: -7px 0; float: inline-end">
                        @if (!drehung.isOn) {
                          <button
                            type="button"
                            class="btn"
                            [title]="'Werte einsetzen' | mrTranslate"
                            tabindex="-1"
                            (click)="copyLinieValue('bis', 'von')">
                            <cds-icon shape="paste" />
                          </button>
                        }
                        <button
                          type="button"
                          class="btn"
                          [title]="'Geoposition orten' | mrTranslate"
                          tabindex="-1"
                          (click)="findPositionAndAutofill('bis')"
                          [clrLoading]="geoState()">
                          <cds-icon shape="map-marker" />
                        </button>
                      </div>
                    </label>
                    <input
                      clrNumberInput
                      formControlName="bis"
                      [value]="linieGr.controls.bis.value | drehung: drehung.summe"
                      (change)="linieGr.controls.bis.setValue(drehungPipe.back($event.target.value, drehung.summe))"
                      type="number"
                      [step]="0.1" />
                    <clr-control-error *clrIfError="'required'">
                      {{ 'Erforderlich' | mrTranslate }}
                    </clr-control-error>
                    @if (linieGr.controls.bis.errors?.min; as err) {
                      <clr-control-error>
                        {{ 'Der Wert ist ' + (!drehung.isOn ? 'kleiner' : 'größer') + ' als' | mrTranslate }}
                        {{ err.min | drehung: drehung.summe }}
                      </clr-control-error>
                    }
                    @if (linieGr.controls.bis.errors?.max; as err) {
                      <clr-control-error>
                        {{ 'Der Wert ist ' + (!drehung.isOn ? 'größer' : 'kleiner') + ' als' | mrTranslate }}
                        {{ err.max | drehung: drehung.summe }}
                      </clr-control-error>
                    }
                  </clr-number-input-container>
                </ng-template>
                <div class="clr-break-row"></div>
              </ng-container>
            }
            @if (gleisGr.enabled) {
              <!-- Gattung + Stamm -->
              <ng-container formGroupName="gleisGr">
                <div [class]="isInspektion() ? 'clr-col' : 'clr-col-12'">
                  <clr-control-container>
                    <label class="clr-required-mark">{{ 'Gattung' | mrTranslate }}</label>
                    <app-datalist-input
                      formControlName="Gattung"
                      placeholder=""
                      [datalist]="listRest.Gattung()"
                      [filteredList]="listFiltered.Gattung()"
                      [tabsTitles]="{ alle: 'Andere', filtered: 'Zugeordnet' }"
                      [insert]="false"
                      [labelPath]="'Bezeichnung'" />
                    <clr-control-error *clrIfError="'required'">
                      {{ 'Erforderlich' | mrTranslate }}
                    </clr-control-error>
                  </clr-control-container>
                </div>
                <div [class]="isInspektion() ? 'clr-col' : 'clr-col-12'">
                  <clr-control-container>
                    <label class="clr-required-mark">{{ 'Stammdaten' | mrTranslate }}</label>
                    <app-datalist-input
                      formControlName="Stamm"
                      placeholder=""
                      [datalist]="listRest.Stamm()"
                      [filteredList]="listFiltered.Stamm()"
                      [tabsTitles]="{ alle: 'Andere', filtered: 'Zugeordnet' }"
                      [insert]="false"
                      [labelPath]="'Bezeichnung'" />
                    <clr-control-error *clrIfError="'required'">
                      {{ 'Erforderlich' | mrTranslate }}
                    </clr-control-error>
                  </clr-control-container>
                </div>
              </ng-container>
            }
            <!-- Prüfart -->
            <div
              [class]="
                isInspektion() ?
                  (typ_Line_Point() | objtype: 'point') ?
                    'clr-col-lg-2'
                  : 'clr-col'
                : 'clr-col-12'
              ">
              <clr-control-container>
                <label class="clr-required-mark">{{ 'Prüfart' | mrTranslate }}</label>
                <app-datalist-input
                  formControlName="Pruefart"
                  [datalist]="listRest.Pruefart()"
                  [filteredList]="listFiltered.Pruefart()"
                  [tabsTitles]="{ alle: 'Andere', filtered: 'Zugeordnet' }"
                  [labelPath]="'Bezeichnung'" />
                <clr-control-error *clrIfError="'required'">
                  {{ 'Erforderlich' | mrTranslate }}
                </clr-control-error>
              </clr-control-container>
            </div>
            @if (formTopGroup.controls.nIO.enabled) {
              <!-- n.I.O. -->
              <div class="clr-col-auto">
                @if (useChecklist()) {
                  <clr-radio-container clrInline style="margin-top: 40px">
                    <clr-radio-wrapper>
                      <input type="radio" clrRadio [value]="false" formControlName="nIO" />
                      <label>{{ 'i.O' | mrTranslate }}</label>
                    </clr-radio-wrapper>
                    <clr-radio-wrapper>
                      <input type="radio" clrRadio [value]="true" formControlName="nIO" />
                      <label>{{ 'n.i.O' | mrTranslate }}</label>
                    </clr-radio-wrapper>
                    <clr-control-error *clrIfError="'required'">
                      {{ 'Erforderlich' | mrTranslate }}
                    </clr-control-error>
                  </clr-radio-container>
                } @else {
                  <clr-toggle-container>
                    <label>{{ 'n.I.O.' | mrTranslate }}</label>
                    <clr-toggle-wrapper>
                      <input type="checkbox" clrToggle formControlName="nIO" />
                    </clr-toggle-wrapper>
                  </clr-toggle-container>
                }
              </div>
            }
            @if (typ_Line_Point() != 2) {
              <div class="clr-break-row"></div>
            }
            @if (mangelGr.enabled) {
              <!-- Lage, Mangel, IH -->
              <!-- Umfang, Meh, FK, BG, Bemerkung -->
              <ng-container formGroupName="mangelGr">
                <div [class]="isInspektion() ? 'clr-col' : 'clr-col-12'">
                  @if (typ_Line_Point() == 4) {
                    <clr-select-container>
                      <label>{{ 'Lage' | mrTranslate }}</label>
                      <select clrSelect [formControl]="gleisGr.controls.LageGleis">
                        <option [ngValue]="null"></option>
                        @let links = 'links' | mrTranslate;
                        @let rechts = 'rechts' | mrTranslate;
                        <option [value]="links">{{ links }}</option>
                        <option [value]="rechts">{{ rechts }}</option>
                        <option [value]="`${links}/${rechts}`">{{ `${links}/${rechts}` }}</option>
                      </select>
                    </clr-select-container>
                  } @else {
                    <clr-control-container>
                      <label class="clr-required-mark">{{ 'Lage' | mrTranslate }}</label>
                      <app-datalist-input
                        formControlName="Lage"
                        [datalist]="listRest.Lage()"
                        [filteredList]="listFiltered.Lage()"
                        [tabsTitles]="{ alle: 'Andere', filtered: 'Zugeordnet' }"
                        [labelPath]="'Bezeichnung'" />
                      <clr-control-error *clrIfError="'required'">
                        {{ 'Erforderlich' | mrTranslate }}
                      </clr-control-error>
                    </clr-control-container>
                  }
                </div>
                <div [class]="isInspektion() ? 'clr-col' : 'clr-col-12'">
                  <clr-control-container>
                    <label class="w-100-p clr-required-mark">
                      {{ 'Mangel' | mrTranslate }}
                      <button
                        type="button"
                        class="btn btn-sm btn-icon btn-outline"
                        style="margin: -7px 0; float: inline-end"
                        tabindex="-1"
                        [title]="'Beschreibung' | mrTranslate"
                        (click)="openHelper()"
                        [disabled]="!formValue.Mangel()?.ID">
                        <cds-icon shape="help" />
                      </button>
                    </label>
                    <app-datalist-input
                      formControlName="Mangel"
                      [datalist]="listRest.Mangel()"
                      [filteredList]="listFiltered.Mangel()"
                      [tabsTitles]="{ alle: 'Andere', filtered: 'Zugeordnet' }"
                      [labelPath]="'Bezeichnung'" />
                    <clr-control-error *clrIfError="'required'">
                      {{ 'Erforderlich' | mrTranslate }}
                    </clr-control-error>
                  </clr-control-container>
                </div>
                <div [class]="isInspektion() ? 'clr-col' : 'clr-col-12'">
                  <clr-control-container>
                    <label class="clr-required-mark">{{ 'Instandsetzung' | mrTranslate }}</label>
                    <app-datalist-input
                      formControlName="Instandsetzung"
                      [datalist]="listRest.Instandsetzung()"
                      [filteredList]="listFiltered.Instandsetzung()"
                      [tabsTitles]="{ alle: 'Andere', filtered: 'Zugeordnet' }"
                      [labelPath]="'Bezeichnung'" />
                    <clr-control-error *clrIfError="'required'">
                      {{ 'Erforderlich' | mrTranslate }}
                    </clr-control-error>
                  </clr-control-container>
                </div>
                <div class="clr-break-row"></div>
                <div [class]="isInspektion() ? 'clr-col-lg-1 clr-col-md-2 clr-col-sm-4 clr-col-6' : 'clr-col-12'">
                  <clr-number-input-container>
                    <label class="d-f row w-100-p">
                      <span class="clr-col nxp ellipsis">{{ 'Umfang' | mrTranslate }}</span>
                      @if (typ_Line_Point() | objtype: 'line') {
                        <button
                          type="button"
                          class="btn btn-sm btn-icon btn-outline clr-col-auto"
                          style="margin: -7px 0; float: inline-end"
                          tabindex="-1"
                          [title]="'Prozentrechner' | mrTranslate"
                          (click)="calModal.open()"
                          [disabled]="linieGr.invalid || (formValue.Umfang() | get: isNotProzent)">
                          <cds-icon shape="calculatur" />
                        </button>
                      }
                    </label>
                    <input clrNumberInput type="number" formControlName="Umfang" [step]="1" />
                    <clr-control-error *clrIfError="'required'">
                      {{ 'Erforderlich' | mrTranslate }}
                    </clr-control-error>
                  </clr-number-input-container>
                </div>
                <div [class]="isInspektion() ? 'clr-col-lg-1 clr-col-md-2 clr-col-sm-4 clr-col-6' : 'clr-col-12'">
                  <clr-select-container>
                    <label class="d-f row w-100-p">
                      <span class="clr-col nxp ellipsis">
                        {{ 'Mengeneinheit' | mrTranslate }}
                      </span>
                      <button
                        type="button"
                        class="btn btn-sm btn-icon btn-outline clr-col-auto"
                        style="margin: -7px 0; float: inline-end"
                        tabindex="-1"
                        [title]="'Tabelle verwalten' | mrTranslate"
                        (click)="isBaseModalOpen.set(true)">
                        <cds-icon shape="pencil" />
                      </button>
                    </label>
                    <select clrSelect formControlName="Mengeneinheit">
                      @for (obj of meh(); track obj.ID) {
                        <option [value]="obj.Bezeichnung">{{ obj.Bezeichnung }}</option>
                      }
                      @if (selectedMangel()?.addMeh) {
                        <option class="invalid-red" [value]="selectedMangel().Mengeneinheit">
                          {{ selectedMangel().Mengeneinheit }}
                        </option>
                      }
                    </select>
                    <clr-control-error *clrIfError="'required'">
                      {{ 'Erforderlich' | mrTranslate }}
                    </clr-control-error>
                  </clr-select-container>
                </div>
                <div [class]="isInspektion() ? 'clr-col-lg-1 clr-col-md-2 clr-col-sm-4 clr-col-6' : 'clr-col-12'">
                  <clr-select-container>
                    <label [class.clr-required-mark]="useFK()">
                      {{ 'Fehlerklasse' | mrTranslate }}
                    </label>
                    <select clrSelect formControlName="FK">
                      <option [ngValue]="null"></option>
                      @for (fk of rangeFK(); track fk) {
                        <option [ngValue]="fk">{{ fk }}</option>
                      }
                    </select>
                    @if (sperrungFK()) {
                      <clr-control-helper>
                        {{ 'FK ist nicht nach unten änderbar' | mrTranslate }}
                      </clr-control-helper>
                    }
                    <clr-control-error *clrIfError="'required'">
                      {{ 'Erforderlich' | mrTranslate }}
                    </clr-control-error>
                  </clr-select-container>
                </div>
                <div [class]="isInspektion() ? 'clr-col-lg-1 clr-col-md-2 clr-col-sm-4 clr-col-6' : 'clr-col-12'">
                  <clr-toggle-container>
                    <label>{{ 'Betriebsgefahr' | mrTranslate }}</label>
                    <clr-toggle-wrapper>
                      <input type="checkbox" clrToggle formControlName="Betriebsgefahr" />
                    </clr-toggle-wrapper>
                  </clr-toggle-container>
                </div>
                @if (useAbteilung()) {
                  <div [class]="isInspektion() ? 'clr-col-lg-3 clr-col-md-3 clr-col-sm-4 clr-col-6' : 'clr-col-12'">
                    <clr-control-container>
                      <label [class.clr-required-mark]="useAbteilung()">
                        {{ 'zuständige Abteilung' | mrTranslate }}
                      </label>
                      <app-datalist-input formControlName="Abteilung" [datalist]="used().zuAbt" />
                      <clr-control-error *clrIfError="'required'">
                        {{ 'Erforderlich' | mrTranslate }}
                      </clr-control-error>
                    </clr-control-container>
                  </div>
                }
                @if (useEquipment()) {
                  <div [class]="isInspektion() ? 'clr-col-lg-2 clr-col-md-3 clr-col-sm-4 clr-col-6' : 'clr-col-12'">
                    <clr-select-container>
                      <label
                        [class]="isInspektion() ? 'clr-col-md-12' : 'clr-col-md-4'"
                        [class.clr-required-mark]="useEquipment()">
                        {{ 'Equipment' | mrTranslate }}
                      </label>
                      <select
                        clrSelect
                        class="clr-col-md-8"
                        [class]="isInspektion() ? 'clr-col-md-12' : 'clr-col-md-8'"
                        formControlName="Equipment">
                        @for (eq of equipments(); track eq) {
                          <option [value]="eq">{{ eq }}</option>
                        }
                      </select>
                      <clr-control-error *clrIfError="'required'">
                        {{ 'Erforderlich' | mrTranslate }}
                      </clr-control-error>
                    </clr-select-container>
                  </div>
                }
                <div [class]="isInspektion() ? 'clr-col' : 'clr-col-12'">
                  <clr-input-container>
                    <label>{{ 'Bemerkung' | mrTranslate }}</label>
                    <input clrInput type="text" formControlName="Bemerkung" />
                  </clr-input-container>
                </div>
              </ng-container>
            }
          </div>
        </form>
        @if (!isInspektion()) {
          <button
            type="submit"
            form="mangel-erfassung-form"
            class="btn btn-primary margin-36-t margin-15-l clr-align-self-start"
            [title]="'Speichern' | mrTranslate"
            [clrLoading]="saveState()">
            {{ 'Speichern' | mrTranslate }}
          </button>
        }
        @if (isInspektion() && table().columns.length) {
          <clr-datagrid
            class="datagrid-compact fill-space"
            [clrDgSelectionType]="'single'"
            [(clrDgSelected)]="selected"
            [clrDgItemsIdentityFn]="row => row?.OMAZSID"
            [clrDgRowSelection]="true">
            <clr-dg-column clrDgField="status" style="min-width: 30px; width: 40px">
              <ng-container *clrDgHideableColumn="{ hidden: isMangelValidStatus() }">
                ✔
              </ng-container>
            </clr-dg-column>
            <clr-dg-column style="min-width: 50px; width: 60px">{{ 'Medien' | mrTranslate }}</clr-dg-column>
            @if (typ_Line_Point() | objtype: 'line') {
              <clr-dg-column
                [clrDgField]="!drehung.isOn ? 'von' : 'bis'"
                [clrDgSortOrder]="direction() * (drehung.isOn ? -1 : 1)">
                {{ 'von' | mrTranslate }}
              </clr-dg-column>
              <clr-dg-column [clrDgField]="!drehung.isOn ? 'bis' : 'von'">
                {{ 'bis' | mrTranslate }}
              </clr-dg-column>
            }
            @for (column of table().columns | array: 'filter' : exceptStartEnd; track column.id) {
              <clr-dg-column [clrDgField]="column.id">
                <ng-container *clrDgHideableColumn="{ hidden: column.id | hideIDColumns: ['b_parentid', 'bild64'] }">
                  {{ column.id | titlecase | mrTranslate }}
                </ng-container>
              </clr-dg-column>
            }
            <clr-dg-row *clrDgItems="let row of table().rows" [clrDgItem]="row">
              <clr-dg-cell style="min-width: 30px; width: 40px">
                @let iOValid = useChecklist() ? row.iO || row.nIO : true;
                @let statusValid = !row.Mangel || (row.Status | compareDate: '>=' : 'day' : datum());
                @if (!iOValid || !statusValid) {
                  <cds-icon class="grid-icon invalid-red" size="20" shape="exclamation-triangle" />
                }
              </clr-dg-cell>
              <clr-dg-cell style="min-width: 50px; width: 60px">
                <cds-icon [shape]="!row.Bild ? 'blank' : 'image-gallery'" size="20" />
              </clr-dg-cell>
              @if (typ_Line_Point() | objtype: 'line') {
                <clr-dg-cell class="name-cell">
                  @let val = row[!drehung.isOn ? 'von' : 'bis'];
                  {{ val | drehung: drehung.summe | tablePrettyPrint }}
                  @if (val === null) {
                    <cds-icon class="grid-icon warning-yellow" solid size="20" shape="exclamation-triangle" />
                  }
                </clr-dg-cell>
              }
              @if (typ_Line_Point() | objtype: 'line') {
                <clr-dg-cell class="name-cell">
                  @let val = row[!drehung.isOn ? 'bis' : 'von'];
                  {{ val | drehung: drehung.summe | tablePrettyPrint }}
                  @if (val === null) {
                    <cds-icon class="grid-icon warning-yellow" solid size="20" shape="exclamation-triangle" />
                  }
                </clr-dg-cell>
              }
              @for (cell of table().columns | array: 'filter' : exceptStartEnd; track cell.id) {
                <clr-dg-cell class="name-cell">{{ row[cell.id] | tablePrettyPrint }}</clr-dg-cell>
              }
            </clr-dg-row>
            <clr-dg-footer>{{ table().rows?.length }} {{ 'Zeilen' | mrTranslate }}</clr-dg-footer>
          </clr-datagrid>
        }
      </div>

      @if (!isInspektion()) {
        <div class="clr-col-lg-6 auto-height-lg-100 d-f col">
          <div class="flex-0-0-auto">
            <app-preview-thumbnails
              [drag_drop]="true"
              [hidden]="mangelGr.disabled"
              [maxAmount]="6"
              (deleteFile)="deletedFiles.push($event)" />
          </div>
          @if (historie) {
            <div class="flex-0-1-auto d-f col" style="min-height: 150px">
              <h3>{{ 'Historie' | mrTranslate }}</h3>
              <div class="scroll">
                <table class="table margin-6-t table-compact nowrap">
                  <thead style="position: sticky; top: 0; z-index: 3">
                    <tr>
                      @for (column of historie.columns; track column.id) {
                        @if (!(column.id | hideIDColumns: ['bildpfad', 'rueckbilder'])) {
                          <th class="left">{{ column.id | titlecase | mrTranslate }}</th>
                        }
                      }
                    </tr>
                  </thead>
                  <tbody>
                    @for (row of historie.rows; track row) {
                      <tr>
                        @for (column of historie.columns; track column.id) {
                          @if (!(column.id | hideIDColumns: ['bildpfad', 'rueckbilder'])) {
                            <td class="left">{{ row[column.id] | tablePrettyPrint }}</td>
                          }
                        }
                      </tr>
                    }
                  </tbody>
                </table>
              </div>
            </div>
          }
          @if (newlyCreated().columns.length) {
            <div class="flex-0-1-auto d-f col" style="min-height: 150px">
              <h3>{{ 'Neu erfasst' | mrTranslate }}</h3>
              <div class="scroll">
                <table class="table margin-6-t table-compact nowrap">
                  <thead style="position: sticky; top: 0; z-index: 3">
                    <tr>
                      @for (column of newlyCreated().columns; track column.id) {
                        @if (!(column.id | hideIDColumns: ['bildpfad', 'rueckbilder'])) {
                          <th class="left">{{ column.id | titlecase | mrTranslate }}</th>
                        }
                      }
                    </tr>
                  </thead>
                  <tbody>
                    @for (row of newlyCreated().rows; track row) {
                      <tr>
                        @for (column of newlyCreated().columns; track column.id) {
                          @if (!(column.id | hideIDColumns: ['bildpfad', 'rueckbilder'])) {
                            <td class="left">{{ row[column.id] | tablePrettyPrint }}</td>
                          }
                        }
                      </tr>
                    }
                  </tbody>
                </table>
              </div>
            </div>
          }
        </div>
      }
    </div>
  </div>
</div>

<clr-modal #calModal [clrModalClosable]="true">
  <h3 class="modal-title">{{ 'Prozentrechner' | mrTranslate }}</h3>
  <div class="modal-body">
    <form clrForm #calForm="ngForm" class="width100 padding-12-r" clrLabelSize="4">
      <clr-number-input-container>
        <label>{{ 'Anzahl pro Schwelle' | mrTranslate }}</label>
        <input clrNumberInput type="number" min="1" ngModel name="anzahl" />
      </clr-number-input-container>
    </form>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-primary" (click)="setFaktor(calForm.value.anzahl); calModal.close()">
      {{ 'OK' | mrTranslate }}
    </button>
    <button type="button" class="btn" (click)="calModal.close()">
      {{ 'Abbrechen' | mrTranslate }}
    </button>
  </div>
</clr-modal>

<app-hilfe-beschreibung-modal
  [(isModalOpen)]="isHelperModalOpen"
  [table]="'SMANG'"
  [id]="openedHelperId()"
  [readonly]="true" />

<app-baseitems-wrapper
  [(isModalOpen)]="isBaseModalOpen"
  [route]="{ tabelle: 'SMEH', title: 'Mengeneinheiten' | mrTranslate }"
  (refresh)="updateMEH($event)" />
